import { useQueryPagination } from "@/services/adapterPaginations"

export type TItensOrders = {
    "auditada": number,
    "codigoProduto": string,
    "divergente": number,
    "idProduto": number,
    "produto": string,
    "solicitada": number
}

export const useItensOrders = ({ dependency }: {
    dependency: {
        produto?: string,
        idAuditoria: number
    }
}) => {
    const res = useQueryPagination<TItensOrders>('acompanhamento/auditoria/expedicao/itens/'+dependency.idAuditoria, dependency)
    return res
}